"use client";

import Layout from "@/components/Layout/Layout";
import { CMSModal } from "@/context";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { ReactNode, useContext } from "react";
import { twMerge } from "tailwind-merge";

const SpacesLayout = ({ children }: { children: ReactNode }) => {
  const { theme } = useContext(CMSModal);
  const pathname = usePathname();

  const tabs = [
    { name: "Bookings", link: "/spaces/bookings" },
    { name: "Resources", link: "/spaces/resources" },
  ];

  return (
    <Layout>
      <div
        className={twMerge(
          "p-10",
          theme === "dark"
            ? "bg-[#262727] text-gray-100"
            : "bg-gray-100 text-[#3b3b3b]",
        )}
      >
        <div className="flex overflow-x-auto scrollbar-hide md:flex-wrap md:overflow-x-visible">
          {tabs.map((tab) => {
            const isActive = pathname === tab.link;
            return (
              <Link
                key={tab.link}
                href={tab.link}
                className={twMerge(
                  "text-sm transition-colors relative cursor-pointer whitespace-nowrap w-52 flex items-center justify-center rounded-t-md shadow-t-sm",
                  isActive
                    ? twMerge(
                        "font-medium px-8 py-2",
                        theme === "dark"
                          ? "bg-[#262727] text-[#f74000]"
                          : "bg-white text-[#f74000]",
                      )
                    : twMerge(
                        "font-medium px-8 py-2",
                        theme === "dark"
                          ? "text-gray-400 hover:text-[#f74000] hover:bg-[#262727]"
                          : "text-gray-400 hover:text-[#f74000] hover:bg-gray-200",
                      ),
                )}
              >
                {tab.name}
              </Link>
            );
          })}
        </div>
        {children}
      </div>
    </Layout>
  );
};

export default SpacesLayout;

